export class State {
  stateName: string;
  stateAbbrev: string;
  countryId: number;

  constructor(json?: any) {
    this.stateName = json.stateName;
    this.stateAbbrev = json.stateAbbrev;
    this.countryId = json.countryId;
  }
}



// WEBPACK FOOTER //
// E:/proj/news12/zb-n12/scadmin/client/src/app/shared/models/State.ts